module.exports = require("!!vue-loader!../node_modules/v-markdown-loader/_cache/components_form-12.vue");


//////////////////
// WEBPACK FOOTER
// ./en/components_form.md
// module id = 558
// module chunks = 583